module.exports = __webpack_public_path__ + "img/go.e11c6323.png";